import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';

@Component({
  selector: 'app-formatos-acta',
  templateUrl: './formatos-acta.component.html',
  styleUrls: ['./formatos-acta.component.scss']
})
export class FormatosActaComponent implements OnInit {
  openTab = 1;
  turnos:any[] = [];
  cobradores:any[] = [];
  jefesTurno:any[] = [];
  constructor(private reporteService:ReporteriaService,
    private ngxUiLoaderService:NgxUiLoaderService,) { }

   ngOnInit(): void {
     this.getData();
  }

  toggleTabs($tabNumber: number){
    this.openTab = $tabNumber;
  }

  async getData() {
    this.ngxUiLoaderService.start('getData');
    this.turnos = await this.getTurnos();
    this.jefesTurno = await this.getJefesTurno(13);
    this.cobradores = await this.getCobradores(22);
    this.ngxUiLoaderService.stop('getData');
  }


  getJefesTurno(tipoUser:number) {
    return this.reporteService.getUsersTipo(tipoUser);
  }

  getCobradores(tipoUser:number) {
    return this.reporteService.getUsersTipo(tipoUser);
  }

  getTurnos() {
    return this.reporteService.getTurnos(); 
  }

}
